var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfitDollar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Global-/-Icons-/-Metrics-/-Gross-Profit-Up",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Global-/-Metric"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Background",
    fill: "#E8F9ED",
    cx: 20,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Global-/-Gross-Profit",
    transform: "translate(10.000000, 10.000000)",
    fill: "#39C258"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1584867,20 L11.1584867,17.6443941 C14.0153374,17.3046433 15.5,15.3567384 15.5,13.3408834 C15.5,11.3023783 13.9928425,9.62627407 11.49591,9.12797282 L11.1584867,9.06002265 L11.1584867,4.41676104 C12.5306748,4.801812 13.2055215,5.97961495 13.3404908,6.8403171 L15.3650307,6.09286523 C15.0051125,4.62061155 13.9253579,2.76330691 11.1584867,2.400906 L11.1584867,0 L9.40388548,0 L9.40388548,2.37825595 C6.88445808,2.69535674 5.10736196,4.53001133 5.10736196,6.6817667 C5.10736196,8.90147225 6.54703476,10.3284258 8.84151329,10.804077 L9.40388548,10.9173273 L9.40388548,15.6511891 C7.62678937,15.3340883 6.77198364,13.9297848 6.63701431,12.4801812 L4.5,13.1596829 C4.74744376,15.1528879 6.27709611,17.3272933 9.40388548,17.6443941 L9.40388548,20 L11.1584867,20 Z M9.40388548,8.65232163 C7.87423313,8.35787089 7.33435583,7.54246886 7.33435583,6.59116648 C7.33435583,5.4813137 8.099182,4.59796149 9.40388548,4.34881087 L9.40388548,8.65232163 Z M11.1584867,15.6511891 L11.1584867,11.2797282 C12.6206544,11.619479 13.295501,12.5028313 13.295501,13.4541336 C13.295501,14.4960362 12.6206544,15.3793884 11.1584867,15.6511891 Z",
    id: "$"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfitDollar);
export default __webpack_public_path__ + "static/media/profit-dollar.1549afad.svg";
export { ForwardRef as ReactComponent };